// extracted by mini-css-extract-plugin
export default {"bg-image":"Home_bg-image__oJgHd","title":"Home_title__49oHQ","title-container":"Home_title-container__yGZzA","home-text":"Home_home-text__2xMM9"};